








































import {Component, Vue} from "vue-property-decorator";
import {FreightServiceAddStore} from "@/modules/freightserviceadds/store";
import {FreightServiceParams} from "@/modules/freightservices/params";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import ServiceTypeLabel from "@/modules/freightservices/List/components/ServiceTypeLabel.vue";
import FreightServiceSearch from "@/modules/freightservices/List/components/Search.vue";
import FreightServiceTableAction from "@/modules/freightservices/List/components/TableAction.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import FreightServiceAddSearch from "@/modules/freightserviceadds/List/components/Search.vue";
import FreightServiceAddTableAction from "@/modules/freightserviceadds/List/components/TableAction.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";

const columns = [
    {
        title: "Thao tác",
        dataIndex: "rowGuid",
        key: "rowGuid",
        scopedSlots: {customRender: 'action'},
        align: 'center',
        width: 100
    },
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 80
    },
    {
        title: "Mã dịch vụ",
        dataIndex: "code",
        key: "code",
        ellipsis: true
    },
    {
        title: "Tên dịch vụ",
        dataIndex: "name",
        key: "name",
        ellipsis: true
    },
    {
        title: "Giá cước",
        dataIndex: "fee",
        key: "fee",
        scopedSlots: {customRender: "fee"},
        ellipsis: true
    },
    {
        title: "Phụ cấp nhận",
        dataIndex: "allowanceReceiver",
        key: "allowanceReceiver",
        scopedSlots: {customRender: "allowanceReceiver"},
        ellipsis: true
    },
    {
        title: "Phụ cấp giao",
        dataIndex: "allowanceDelivery",
        key: "allowanceDelivery",
        scopedSlots: {customRender: "allowanceDelivery"},
        ellipsis: true
    },
    {
        title: "Ghi chú",
        dataIndex: "note",
        key: "note",
        ellipsis: true
    },
    {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
        scopedSlots: {customRender: 'status'},
        ellipsis: true
    }
];

@Component({
    name: "FreightServiceAddList",
    components: {
        FreightServiceAddTableAction,
        FreightServiceAddSearch,
        FreightServiceTableAction, FreightServiceSearch, ServiceTypeLabel, CommonStatusLabel
    }
})
export default class extends mixins(CommonMixin) {
    columns = columns;

    created() {
        if (this.isAdmin) {
            this.columns = [
                ...columns,
                {
                    title: "Bưu cục áp dụng",
                    dataIndex: "postOffice.name",
                    key: "postOfficeRowGuid",
                    width: 150,
                    ellipsis: true
                } as any
            ]
        }

        FreightServiceAddStore.updateFreightServiceAddParams(new FreightServiceParams());
        FreightServiceAddStore.listFreightServiceAdd(FreightServiceAddStore.params);
    }

    get freightServiceAdds() {
        return FreightServiceAddStore.ids.map((id: string) => FreightServiceAddStore.data[id]);
    }

    get pagination() {
        return {
            current: FreightServiceAddStore.meta.page,
            pageSize: FreightServiceAddStore.meta.limit,
            total: FreightServiceAddStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} dịch vụ`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        FreightServiceAddStore.listFreightServiceAdd({
            ...FreightServiceAddStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        });
    }
}
